import ImageCropViewWeb from "./ImageCropViewWeb";
export default ImageCropViewWeb;